import './App.css';
import LoteryGame from './components/LoteryGame';

function App() {
  return (
    <div className="App">
      <LoteryGame />
    </div>
  );
}

export default App;
